import { render, staticRenderFns } from "./chooseCrystal.vue?vue&type=template&id=5399be82&scoped=true&"
import script from "./chooseCrystal.vue?vue&type=script&lang=js&"
export * from "./chooseCrystal.vue?vue&type=script&lang=js&"
import style0 from "./chooseCrystal.vue?vue&type=style&index=0&id=5399be82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5399be82",
  null
  
)

export default component.exports